import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef, createElementBlock as _createElementBlock } from "vue"

import {   ref, Ref, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  props: {
    params: null
  },
  setup(__props: any) {

const props = __props as {
  params?: any
}

let { 
  // 获取订单
  'POST/order/receivable/orders': fetchList,
} = Api


const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

console.log(props.params);
fetchData(props.params)


return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      "max-height": "660px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "订单号",
          prop: "no",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "订单名称",
          prop: "name",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "po号",
          prop: "po",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "客户",
          prop: "customerUsername",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "联系人",
          prop: "customerContacter",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "客户经理",
          prop: "",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "项目经理",
          prop: "pm",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "总金额",
          prop: "amount"
        }),
        _createVNode(_component_el_table_column, {
          label: "usd金额",
          prop: "standardMoney"
        }),
        _createVNode(_component_el_table_column, {
          label: "开始日期",
          prop: "startTime",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "结束日期",
          prop: "endDate",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "状态",
          prop: "status"
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      small: "",
      background: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[1] || (_cache[1] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mb-5 mt-5",
      "page-sizes": [10, 30, 50],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
  ]))
}
}

})